module.exports = {
  'defaultFont': '"Proxima Nova","Helvetica Neue",Helvetica,Arial,sans-serif'
};
